import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, getDocs, query, where, doc, getDoc, updateDoc, limit, startAfter, orderBy, addDoc, Timestamp, deleteDoc, setDoc } from 'firebase/firestore';
import { useLocation } from 'react-router-dom';
import '../style/OrdersPage.css';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';

const PaidOrdersPage = () => {
    const [paidOrders, setPaidOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editedOrderData, setEditedOrderData] = useState({});
    const [isSearching, setIsSearching] = useState(false);
    const [trackingLoading, setTrackingLoading] = useState({});
    
    // New state for modal type
    const [modalType, setModalType] = useState('view'); // 'view', 'cancel', 'edit'
    const [processingCancel, setProcessingCancel] = useState(false);
    const [processingSave, setProcessingSave] = useState(false);
    
    // Pagination state
    const [lastVisible, setLastVisible] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const PAGE_SIZE = 10;
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // const shopId = queryParams.get('shop');

    const user = auth.currentUser;
    if (!user) {
        throw new Error("User not logged in");
    }


    // Check if order is shipped
    // const checkOrderShippingStatus = async (orderId) => {
    //     try {
    //         const confirmedOrdersRef = collection(db, 'users', user.uid, 'confirmed_orders');
    //         const q = query(confirmedOrdersRef, where('channel_order_id', '==', orderId));
    //         const snapshot = await getDocs(q);
            
    //         if (!snapshot.empty) {
    //             const orderDoc = snapshot.docs[0];
    //             const orderData = orderDoc.data();
    //             return orderData.shipping_status !== 'shipped';
    //         }
    //         return true; // If no confirmed order found, allow cancellation
    //     } catch (error) {
    //         console.error("Error checking shipping status:", error);
    //         return false; // If error, don't allow cancellation
    //     }
    // };


//     const checkOrderShippingStatus = async (orderId) => {
//     try {
//         const confirmedOrdersRef = collection(db, 'users', user.uid, 'confirmed_orders');
//         const q = query(confirmedOrdersRef, where('data.refrence_id', '==', orderId));
//         const snapshot = await getDocs(q);
        
//         if (!snapshot.empty) {
//             const orderDoc = snapshot.docs[0];
//             const orderData = orderDoc.data();
//             return orderData.shipping_status !== 'shipped';
//         }
//         return true; // If no confirmed order found, allow cancellation
//     } catch (error) {
//         console.error("Error checking shipping status:", error);
//         return false; // If error, don't allow cancellation
//     }
// };

const checkOrderShippingStatus = async (orderId) => {
    try {
        const confirmedOrdersRef = collection(db, 'users', user.uid, 'confirmed_orders');
        
        // Query for channel_order_id
        const q1 = query(confirmedOrdersRef, where('channel_order_id', '==', orderId));
        const snapshot1 = await getDocs(q1);
        
        // Query for data.refrence_id
        const q2 = query(confirmedOrdersRef, where('data.refrence_id', '==', orderId));
        const snapshot2 = await getDocs(q2);
        
        // Check if either query found results
        if (!snapshot1.empty) {
            const orderDoc = snapshot1.docs[0];
            const orderData = orderDoc.data();
            return orderData.shipping_status !== 'shipped';
        }
        
        if (!snapshot2.empty) {
            const orderDoc = snapshot2.docs[0];
            const orderData = orderDoc.data();
            return orderData.shipping_status !== 'shipped';
        }
        
        return true; // If no confirmed order found, allow cancellation
    } catch (error) {
        console.error("Error checking shipping status:", error);
        return false; // If error, don't allow cancellation
    }
};


    // const fetchTrackingData = async (orderId) => {
    //     try {
    //         setTrackingLoading(prev => ({ ...prev, [orderId]: true }));
            
    //         const response = await axios.get(`https://ufb-1.onrender.com/api/track-order?order_id=${orderId}`);
            
    //         if (response.data && response.data.tracking_url) {
    //             // Update the order with tracking URL in local state
    //             setPaidOrders(prevOrders => 
    //                 prevOrders.map(order => 
    //                     order.id === orderId 
    //                         ? { ...order, tracking_url: response.data.tracking_url } 
    //                         : order
    //                 )
    //             );
                
    //             // Also update filtered orders
    //             setFilteredOrders(prevFiltered => 
    //                 prevFiltered.map(order => 
    //                     order.id === orderId 
    //                         ? { ...order, tracking_url: response.data.tracking_url } 
    //                         : order
    //                 )
    //             );
                
    //             // Open the tracking URL in a new tab
    //             window.open(response.data.tracking_url, '_blank');
                
    //             return {
    //                 tracking_url: response.data.tracking_url,
    //             };
    //         }
    //     } catch (error) {
    //         console.error("Error fetching tracking data for order", orderId, error);
    //         alert("Failed to fetch tracking information. Please try again.");
    //     } finally {
    //         setTrackingLoading(prev => ({ ...prev, [orderId]: false }));
    //     }
    //     return { tracking_url: null };
    // };



    // Fetch paid orders from Firestore - modified to support pagination and sorting by date
  
  const fetchTrackingData = async (orderId) => {
    try {
        const response = await axios.get(`https://ufb-1.onrender.com/api/track-order?order_id=${orderId}`);
        
        if (response.data && response.data.tracking_url) {
            // Update the order with tracking URL in local state
            setPaidOrders(prevOrders => 
                prevOrders.map(order => 
                    order.id === orderId 
                        ? { ...order, tracking_url: response.data.tracking_url } 
                        : order
                )
            );
            
            // Also update filtered orders
            setFilteredOrders(prevFiltered => 
                prevFiltered.map(order => 
                    order.id === orderId 
                        ? { ...order, tracking_url: response.data.tracking_url } 
                        : order
                )
            );
            
            // Open the tracking URL in a new tab
            window.open(response.data.tracking_url, '_blank');
            
            return {
                success: true,
                tracking_url: response.data.tracking_url,
            };
        } else {
            return {
                success: false,
                tracking_url: null,
            };
        }
    } catch (error) {
        console.error("Error fetching tracking data for order", orderId, error);
        return {
            success: false,
            tracking_url: null,
        };
    }
};
  
  
  
    const fetchPaidOrders = async (isLoadMore = false) => {
        try {
            if (isLoadMore) {
                setLoadingMore(true);
            } else {
                setLoading(true);
            }
            
            const ordersCollection = collection(db, 'users', user.uid, 'orders');
            let q;
            
            if (isLoadMore && lastVisible) {
                // Fetch next batch of orders
                q = query(
                    ordersCollection, 
                    where('isPaid', '==', true),
                    where('status', '==', 'confirmed'),
                    orderBy('order_date', 'desc'), // Sort by order_date desc (newest first)
                    startAfter(lastVisible),
                    limit(PAGE_SIZE)
                );
            } else {
                // Fetch first batch of orders
                q = query(
                    ordersCollection, 
                    where('isPaid', '==', true),
                    where('status', '==', 'confirmed'),
                    orderBy('order_date', 'desc'), // Sort by order_date desc (newest first)
                    limit(PAGE_SIZE)
                );
            }
            
            const ordersSnapshot = await getDocs(q);
            
            // If we got fewer results than the page size, there are no more results
            if (ordersSnapshot.docs.length < PAGE_SIZE) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }
            
            // Set last document for pagination
            if (ordersSnapshot.docs.length > 0) {
                setLastVisible(ordersSnapshot.docs[ordersSnapshot.docs.length - 1]);
            }
            
            const ordersList = ordersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            if (isLoadMore) {
                // Append to existing orders
                setPaidOrders(prevOrders => [...prevOrders, ...ordersList]);
            } else {
                // Replace all orders
                setPaidOrders(ordersList);
            }
        } catch (error) {
            console.error("Error fetching paid orders:", error);
            alert("Error loading orders. Please try again.");
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };


const getAwbNumber = async (orderId) => {
    try {
        console.log("Fetching AWB for order:", orderId);
        console.log("User UID:", user.uid);
        
        // Firebase v9 syntax - using doc() and getDoc()
        const confirmedOrderDocRef = doc(db, 'users', user.uid, 'confirmed_orders', orderId);
        const confirmedOrderDoc = await getDoc(confirmedOrderDocRef);
        
        console.log("Document exists:", confirmedOrderDoc.exists());
        
        if (confirmedOrderDoc.exists()) {
            const orderData = confirmedOrderDoc.data();
            console.log("Order data:", orderData);
            console.log("AWB Number:", orderData.awbNumber);
            return orderData.awbNumber || null;
        } else {
            console.error("No confirmed_orders document found for order ID:", orderId);
            return null;
        }
    } catch (error) {
        console.error("Error fetching AWB number from confirmed_orders:", error);
        return null;
    }
};



    // const handleTrackOrder = async (orderId, e) => {
    //     e.stopPropagation(); // Prevent opening the modal when clicking on tracking button
    //     await fetchTrackingData(orderId);
    // };

    // New function to search for order by ID directly in Firestore
   
const handleTrackOrder = async (orderId, e) => {
    e.stopPropagation(); // Prevent opening the modal when clicking on tracking button
    
    try {
        setTrackingLoading(prev => ({ ...prev, [orderId]: true }));
        
        // First, try the original tracking method
        console.log("Attempting original tracking method for order:", orderId);
        const originalTrackingResult = await fetchTrackingData(orderId);
        
        // Check if original tracking was successful
        if (originalTrackingResult && originalTrackingResult.success) {
            console.log("Original tracking successful");
            return; // Exit early if original tracking worked
        }
        
        // If original tracking failed, try AWB tracking method
        console.log("Original tracking failed, attempting AWB tracking method");
        
        // Get AWB number from confirmed_order Firestore document
        const awbNumber = await getAwbNumber(orderId);
        
        if (awbNumber) {
            const shipmozoTrackingUrl = `https://panel.shipmozo.com/track-order?awb=${awbNumber}`;
            
            // Update the order with tracking URL in local state
            setPaidOrders(prevOrders => 
                prevOrders.map(order => 
                    order.id === orderId 
                        ? { ...order, tracking_url: shipmozoTrackingUrl } 
                        : order
                )
            );
            
            // Also update filtered orders
            setFilteredOrders(prevFiltered => 
                prevFiltered.map(order => 
                    order.id === orderId 
                        ? { ...order, tracking_url: shipmozoTrackingUrl } 
                        : order
                )
            );
            
            // Open the Shipmozo tracking URL in a new tab
            window.open(shipmozoTrackingUrl, '_blank');
            console.log("AWB tracking successful");
        } else {
            alert("Tracking information not available for this order.");
            console.error("Both tracking methods failed for order:", orderId);
        }
        
    } catch (error) {
        console.error("Error in handleTrackOrder for order", orderId, error);
        alert("Failed to fetch tracking information. Please try again.");
    } finally {
        setTrackingLoading(prev => ({ ...prev, [orderId]: false }));
    }
};
   
    const searchOrderById = async (searchId) => {
        try {
            setIsSearching(true);
            
            // Search by order ID (document ID)
            const ordersCollection = collection(db, 'users', user.uid, 'orders');
            let results = [];
            
            // Search for direct match on document ID
            if (searchId.trim()) {
                try {
                    const orderDoc = doc(db, 'users', user.uid, 'orders', searchId.trim());
                    const orderSnapshot = await getDocs(query(
                        ordersCollection,
                        where('__name__', '==', searchId.trim()),
                        where('status', '==', 'confirmed'),
                        where('isPaid', '==', true)
                    ));
                    
                    if (!orderSnapshot.empty) {
                        const orderData = orderSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                        results = [...results, ...orderData];
                    }
                } catch (err) {
                    console.log("Error searching by document ID:", err);
                }
                
                // Search by Store Order ID
                try {
                    const storeOrderSnapshot = await getDocs(query(
                        ordersCollection,
                        where('Storeorder_id', '==', searchId.trim()),
                        where('isPaid', '==', true)
                    ));
                    
                    if (!storeOrderSnapshot.empty) {
                        const storeOrderData = storeOrderSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                        results = [...results, ...storeOrderData];
                    }
                } catch (err) {
                    console.log("Error searching by store order ID:", err);
                }
                
                // If exact matches didn't find anything, try contains for store order ID
                if (results.length === 0) {
                    try {
                        // For contains queries, we need to get all documents and filter client-side
                        const allOrdersSnapshot = await getDocs(query(
                            ordersCollection,
                            where('isPaid', '==', true),
                            where('status', '==', 'confirmed'),
                        ));
                        
                        const containsMatches = allOrdersSnapshot.docs
                            .map(doc => ({ id: doc.id, ...doc.data() }))
                            .filter(order => 
                                (order.Storeorder_id && order.Storeorder_id.includes(searchId.trim())) ||
                                order.id.includes(searchId.trim())
                            );
                        
                        results = [...results, ...containsMatches];
                    } catch (err) {
                        console.log("Error performing contains search:", err);
                    }
                }
            }
            
            setFilteredOrders(results);
            setIsSearching(false);
        } catch (error) {
            console.error("Error searching for order:", error);
            setIsSearching(false);
        }
    };

    // Handle search input change with debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        
        if (value.trim() === '') {
            // If search is cleared, show the loaded orders
            setFilteredOrders(paidOrders);
        } else {
            // When user is typing, first filter locally
            const localFiltered = paidOrders.filter(order => 
                order.id.includes(value) || 
                (order.Storeorder_id && order.Storeorder_id.includes(value))
            );
            
            setFilteredOrders(localFiltered);
            
            // If we have a search term of at least 3 characters, search Firestore
            if (value.trim().length >= 3) {
                // Use debounce to avoid too many Firestore queries
                const timeoutId = setTimeout(() => {
                    searchOrderById(value);
                }, 500);
                
                return () => clearTimeout(timeoutId);
            }
        }
    };

    // Load more orders - new function
    const handleLoadMore = () => {
        if (hasMore && !loadingMore) {
            fetchPaidOrders(true);
        }
    };

    // Handle invoice download - unchanged
    const handleDownloadInvoice = (invoiceUrl) => {
        if (invoiceUrl) {
            window.open(invoiceUrl, '_blank');
        } else {
            alert('Invoice not available for this order.');
        }
    };

    // Open order details modal - modified to check shipping status
    const openOrderModal = async (order) => {
        const canCancel = await checkOrderShippingStatus(order.id);
        setSelectedOrder(order);
        setEditedOrderData({ ...order });
        setModalType(canCancel ? 'view' : 'view_only');
        setIsModalOpen(true);
    };

    // Close the modal - unchanged
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedOrder(null);
        setEditedOrderData({});
        setModalType('view');
    };

    // Handle input change for order editing - unchanged
    const handleOrderDataChange = (field, value) => {
        setEditedOrderData(prevData => ({
            ...prevData,
            [field]: value
        }));
    };

    // Handle line item changes
    const handleLineItemChange = (index, field, value) => {
        setEditedOrderData(prevData => ({
            ...prevData,
            order_items: prevData.order_items.map((item, i) => 
                i === index ? { ...item, [field]: value } : item
            )
        }));
    };

    // Handle order cancellation
const handleCancelOrder = async () => {
    if (!selectedOrder) return;

    // Check if order is already cancelled
    if (selectedOrder.status === 'cancelled') {
        alert("This order has already been cancelled.");
        return;
    }

    try {
        setProcessingCancel(true);

        // Cancel the order
        const orderRef = doc(db, 'users', user.uid, 'orders', selectedOrder.id);
        await updateDoc(orderRef, {
            status: 'cancelled',
            cancelledAt: Timestamp.now()
        });

        // Fetch the wallet document
        const walletRef = doc(db, 'users', user.uid, 'wallet', 'walletDetails');
        const walletSnap = await getDoc(walletRef);

        let currentBalance = 0;
        if (walletSnap.exists()) {
            const walletData = walletSnap.data();
            currentBalance = walletData.balance || 0;
        }

        // Prepare credit and transaction details
        const creditAmount = selectedOrder.UniteeTotalPrice || selectedOrder.total || 0;
        const balanceBefore = currentBalance;
        const balanceAfter = balanceBefore + creditAmount;

        const transactionData = {
            type: 'Order Cancellation',
            amount: creditAmount,
            balanceBefore,
            balanceAfter,
            timestamp: Timestamp.now(),
            CNtype: "nonGSTcreditNote",
            orderId: selectedOrder.id,
            reason: 'Order Cancellation'
        };

        // Add transaction
        const transactionsCollection = collection(
            db, 
            'users', 
            user.uid, 
            'wallet', 
            'walletDetails', 
            'transactions'
        );
        await addDoc(transactionsCollection, transactionData);

        // Update wallet balance
        await updateDoc(walletRef, {
            balance: balanceAfter,
            lastUpdated: Timestamp.now()
        });

        // Update local state
        setPaidOrders(prevOrders =>
            prevOrders.map(order =>
                order.id === selectedOrder.id
                    ? { ...order, status: 'cancelled' }
                    : order
            )
        );

        setFilteredOrders(prevFiltered =>
            prevFiltered.map(order =>
                order.id === selectedOrder.id
                    ? { ...order, status: 'cancelled' }
                    : order
            )
        );

        alert("Order cancelled successfully and amount credited to wallet!");
        closeModal();

    } catch (error) {
        console.error("Error cancelling order:", error);
        alert("Failed to cancel order. Please try again.");
    } finally {
        setProcessingCancel(false);
    }
};



const saveOrderChanges = async () => {
    if (!selectedOrder) return;

    try {
        setProcessingSave(true);

        // Delete the old order
        const oldOrderRef = doc(db, 'users', user.uid, 'orders', selectedOrder.id);
        await deleteDoc(oldOrderRef);

        // Create new order with updated data and custom ID
        const ordersCollection = collection(db, 'users', user.uid, 'orders');
        const newOrderId = `edit_${selectedOrder.id}`;
        const newOrderRef = doc(ordersCollection, newOrderId);
        const newOrderData = {
            ...editedOrderData,
            id: newOrderId,           // Override with new ID
            order_id: newOrderId,     // Override with new order_id
            createdAt: Timestamp.now(),
            updatedAt: Timestamp.now(),
            originalOrderId: selectedOrder.id
        };
        await setDoc(newOrderRef, newOrderData);

        // Call the create-shiprocket-order API
        try {
            const response = await axios.post('https://ufb-1.onrender.com/create-shipmozo-order', {
                ...editedOrderData,
                id: newOrderId,           // Override with new ID for API call too
                order_id: newOrderId,     // Override with new order_id for API call
                user_uid: user.uid
            });

            console.log('New Shiprocket order created:', response.data);

        } catch (apiError) {
            console.error("Error creating Shiprocket order:", apiError);
            // Continue even if API call fails
        }

        // Update local state
        setPaidOrders(prevOrders => {
            const filtered = prevOrders.filter(order => order.id !== selectedOrder.id);
            return [{ id: newOrderId, ...newOrderData }, ...filtered];
        });

        setFilteredOrders(prevFiltered => {
            const filtered = prevFiltered.filter(order => order.id !== selectedOrder.id);
            return [{ id: newOrderId, ...newOrderData }, ...filtered];
        });

        alert("Order updated successfully!");
        closeModal();

    } catch (error) {
        console.error("Error updating order:", error);
        alert("Failed to update order. Please try again.");
    } finally {
        setProcessingSave(false);
    }
};


    // Load paid orders on component mount
    useEffect(() => {
        setLastVisible(null);
        setHasMore(true);
        fetchPaidOrders();
    }, [user]);

    // Filter orders based on date range - updated to not filter by search term as we handle that separately
    useEffect(() => {
        let filtered = paidOrders;
        
        // Only filter by search term if it's not actively searching in Firestore
        if (searchTerm && !isSearching) {
            filtered = filtered.filter(order => 
                order.id.includes(searchTerm) || 
                (order.Storeorder_id && order.Storeorder_id.includes(searchTerm))
            );
        }
        
        // Filter by date range
        if (startDate && endDate) {
            filtered = filtered.filter(order => {
                if (!order.order_date) return false;
                
                const orderDate = new Date(order.order_date);
                const start = new Date(startDate);
                const end = new Date(endDate);
                
                // Set end date to end of day
                end.setHours(23, 59, 59, 999);
                
                return orderDate >= start && orderDate <= end;
            });
        }
        
        // Only update filtered orders if not actively searching
        if (!isSearching || searchTerm.trim() === '') {
            setFilteredOrders(filtered);
        }
    }, [startDate, endDate, paidOrders]);

    // Update filtered orders when search term changes, but only for local filtering
    useEffect(() => {
        if (!isSearching && searchTerm.trim() === '') {
            setFilteredOrders(paidOrders);
        }
    }, [searchTerm, isSearching, paidOrders]);

    if (loading && !loadingMore && !isSearching) {
        return <div>Loading paid orders...</div>;
    }

   return (
    <div className="orders-page">
        <Header />
        <div className="orders-container">
            <Sidebar />
            <div className="main-content">
                <h1>Paid Orders</h1>
                
                <div className="filters-container">
                    <input 
                        type="text" 
                        placeholder="Search by Order ID or Store Order ID" 
                        value={searchTerm} 
                        onChange={handleSearchChange} 
                        className="search-bar"
                    />
                    
                    <div className="date-filters">
                        <div className="date-filter">
                            <label>From Date:</label>
                            <input 
                                type="date" 
                                value={startDate} 
                                onChange={(e) => setStartDate(e.target.value)} 
                            />
                        </div>
                        
                        <div className="date-filter">
                            <label>To Date:</label>
                            <input 
                                type="date" 
                                value={endDate} 
                                onChange={(e) => setEndDate(e.target.value)} 
                            />
                        </div>
                    </div>
                </div>
                
                {isSearching && (
                    <div style={{ textAlign: 'center', margin: '20px 0' }}>
                        Searching for orders...
                    </div>
                )}
                
                {filteredOrders.length > 0 ? (
                    <table className="orders-table">
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Unitee Order ID</th>
                                <th>Order Date</th>
                                <th>SKU</th>
                                <th>Quantity</th>
                                {/* <th>Status</th> */}
                                <th>Invoice</th>
                                <th>Tracking Status</th>
                                <th>Track Order</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredOrders.map((order) => (
                                <tr key={order.id}>
                                    <td 
                                        className="order-id-cell" 
                                        onClick={() => openOrderModal(order)}
                                    >
                                        {order.Storeorder_id || 'NA'}
                                    </td>
                                    <td>{order.id || 'NA'}</td>
                                    <td>{order.order_date ? new Date(order.order_date).toLocaleDateString() : 'NA'}</td>
                                    <td>
                                        {order.order_items?.map((item, index) => (
                                            <p key={index}>{item.sku}</p>
                                        ))}
                                    </td>
                                    <td>
                                        {order.order_items?.map((item, index) => (
                                            <p key={index}>{item.units}</p>
                                        ))}
                                    </td>
                                    {/* <td style={{ color: order.status === 'cancelled' ? 'red' : 'green' }}>
                                        {order.status || 'Active'}
                                    </td> */}
                                    <td>
                                        {order.invoiceUrl ? (
                                            <button 
                                                onClick={() => handleDownloadInvoice(order.invoiceUrl)} 
                                                className="download-invoice-btn"
                                            >
                                                Download Invoice
                                            </button>
                                        ) : (
                                            <span>No Invoice</span>
                                        )}
                                    </td>
                                    <td style={{ color: 'blue' }}>{order.tracking_status || 'NA'}</td>
                                    <td>
                                        <button
                                            onClick={(e) => handleTrackOrder(order.id, e)}
                                            disabled={trackingLoading[order.id]}
                                            className="track-order-btn"
                                        >
                                            {trackingLoading[order.id] ? 'Loading...' : 'Track Order'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="no-orders-message">
                        {isSearching ? 'Searching...' : 'No paid orders found.'}
                    </div>
                )}
                
                {/* Load More Button - only show when not searching or filtering */}
                {!searchTerm && !startDate && !endDate && hasMore && (
                    <div className="load-more-container" style={{ textAlign: 'center', margin: '20px 0' }}>
                        <button 
                            className="load-more-btn" 
                            onClick={handleLoadMore}
                            disabled={loadingMore}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#4a90e2',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: loadingMore ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {loadingMore ? 'Loading...' : 'Load More Orders'}
                        </button>
                    </div>
                )}
                
                {loadingMore && (
                    <div style={{ textAlign: 'center', margin: '10px 0' }}>
                        Loading more orders...
                    </div>
                )}
            </div>
        </div>
        
        {/* Order Details Modal - Enhanced with Cancel/Edit functionality */}
        {isModalOpen && selectedOrder && (
            <div className="modal-overlay">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2>Order Details</h2>
                        <button className="close-btn" onClick={closeModal}>×</button>
                    </div>
                    
                    <div className="modal-body">
                        <div className="form-group">
                            <label>Store Order ID:</label>
                            <input 
                                type="text" 
                                value={editedOrderData.Storeorder_id || ''} 
                                disabled={modalType !== 'edit'}
                                                                      style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                            />
                        </div>
                        
                        <div className="form-group">
                            <label>Unitee Order ID:</label>
                            <h3>{selectedOrder.id}</h3>
                        </div>
                        
                        <div className="form-row">
                        </div>
                        
                        <h3>Billing Information</h3>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Customer Name:</label>
                                <input 
                                    type="text" 
                                    value={editedOrderData.billing_customer_name || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_customer_name', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                      style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>Last Name:</label>
                                <input 
                                    type="text" 
                                    value={editedOrderData.billing_last_name || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_last_name', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                                                          style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                        </div>
                        
                        <div className="form-row">
                            <div className="form-group">
                                <label>Email:</label>
                                <input 
                                    type="email" 
                                    value={editedOrderData.billing_email || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_email', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                                                          style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>Phone:</label>
                                <input 
                                    type="text" 
                                    value={editedOrderData.billing_phone || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_phone', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                                                          style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                        </div>
                        
                        <div className="form-group">
                            <label>Address:</label>
                            <input 
                                type="text" 
                                value={editedOrderData.billing_address || ''} 
                                onChange={(e) => handleOrderDataChange('billing_address', e.target.value)}
                                disabled={modalType !== 'edit'}
                                                                      style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                            />
                        </div>
                        
                        <div className="form-row">
                            <div className="form-group">
                                <label>City:</label>
                                <input 
                                    type="text" 
                                    value={editedOrderData.billing_city || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_city', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                                                          style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>State:</label>
                                <input 
                                    type="text" 
                                    value={editedOrderData.billing_state || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_state', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                                                          style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                        </div>
                        
                        <div className="form-row">
                            <div className="form-group">
                                <label>Pincode:</label>
                                <input 
                                    type="text" 
                                    value={editedOrderData.billing_pincode || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_pincode', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                                                          style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>Country:</label>
                                <input 
                                    type="text" 
                                    value={editedOrderData.billing_country || ''} 
                                    onChange={(e) => handleOrderDataChange('billing_country', e.target.value)}
                                    disabled={modalType !== 'edit'}
                                                                          style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                                />
                            </div>
                        </div>
                        
                        <div className="form-group">
                            <label>Payment Method:</label>
                            <input 
                                type="text" 
                                value={editedOrderData.payment_method || ''} 
                                disabled
                                                                      style={{
    backgroundColor: modalType !== 'edit' ? '#fff' : undefined,
    color: modalType !== 'edit' ? '#000' : undefined,
    cursor: modalType !== 'edit' ? 'text' : undefined
  }}
                            />
                        </div>
                        
                        <h3>Order Items</h3>
                        {editedOrderData.order_items && editedOrderData.order_items.map((item, index) => {
                            const skuParts = item.sku ? item.sku.split('-') : [];
    const baseSku = skuParts.slice(0, 2).join('-'); // "u-56755"
    const currentSize = skuParts[2] || ''; // "M"
    const extraParts = skuParts.slice(3); // Anything after size, e.g. ["black"]

    const availableSizes = ['S', 'M', 'L', 'XL']; // Modify as needed

    const handleSizeChange = (newSize) => {
        const newSku = [baseSku, newSize, ...extraParts].join('-');
        handleLineItemChange(index, 'sku', newSku);
    };
                            
                            return (
                                <div key={index} className="order-item">
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>SKU:</label>
                                            <input 
                                                type="text" 
                                                value={item.sku || ''} 
                                                disabled
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Quantity:</label>
                                            <input 
                                                type="number" 
                                                value={item.units || ''} 
                                                // onChange={(e) => handleLineItemChange(index, 'units', parseInt(e.target.value))}
                                                disabled={modalType !== 'edit'}
                                            />
                                        </div>
                                        
                                        {modalType === 'edit' && (
                                            <div className="form-group">
                                                <label>Size:</label>
                                                <select
                                                    value={currentSize}
                                                    onChange={(e) => handleSizeChange(e.target.value)}
                                                >
                                                    {availableSizes.map(size => (
                                                        <option key={size} value={size}>{size}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    
                    <div className="modal-footer">
                        {modalType === 'view' && (
                            <>
                                <button 
                                    className="cancel-order-btn" 
                                    onClick={() => setModalType('cancel')}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        marginRight: '10px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel Order
                                </button>
                                <button 
                                    className="edit-order-btn" 
                                    onClick={() => setModalType('edit')}
                                    style={{
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Edit Order
                                </button>
                            </>
                        )}
                        
                        {/* {modalType === 'cancel' && (
                            <>
                                <p style={{ color: 'red', marginBottom: '15px' }}>
                                    Are you sure you want to cancel this order? The amount will be credited to your wallet.
                                </p>
                                <button 
                                    className="confirm-cancel-btn" 
                                    onClick={handleCancelOrder}
                                    disabled={processingCancel}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        marginRight: '10px',
                                        cursor: processingCancel ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {processingCancel ? 'Cancelling...' : 'Confirm Cancel'}
                                </button>
                                <button 
                                    className="back-btn" 
                                    onClick={() => setModalType('view')}
                                    style={{
                                        backgroundColor: '#6c757d',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Back
                                </button>
                            </>
                        )} */}




                        {modalType === 'cancel' && (
    <div className="modals">
        <div className="modal-contents">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to Cancel this order?</p>
            <div className="modal-actions">
                <button 
                    className="cancel-order-btn"
                                                        style={{
                                        backgroundColor: '#dc3545',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        marginRight: '10px',
                                        cursor: 'pointer'
                                    }}
                     onClick={handleCancelOrder}
                    disabled={processingCancel}
                >
                     {processingCancel ? 'Cancelling...' : 'Confirm Cancel'}
                </button>

               
                <button 
                    className="btn-confirm"
                      onClick={() => setModalType('view')}
                >
                     Back
                </button>
            </div>
        </div>
    </div>
)}


                        
                        {modalType === 'edit' && (
                            <>
                                <button 
                                    className="save-changes-btn" 
                                    onClick={saveOrderChanges}
                                    disabled={processingSave}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        marginRight: '10px',
                                        cursor: processingSave ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {processingSave ? 'Saving...' : 'Save Changes'}
                                </button>
                                <button 
                                    className="cancel-edit-btn" 
                                    onClick={() => {
                                        setModalType('view');
                                        setEditedOrderData({ ...selectedOrder });
                                    }}
                                    style={{
                                        backgroundColor: '#6c757d',
                                        color: 'white',
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel Edit
                                </button>
                            </>
                        )}
                        
                        {modalType === 'view_only' && (
                            <p style={{ color: '#ffc107', fontWeight: 'bold' }}>
                                This order has been shipped and cannot be cancelled or edited.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        )}
    </div>
);

}

export default PaidOrdersPage;